/**
 * Returns an openlayers color
 * https://openlayers.org/en/latest/apidoc/module-ol_color.html#~Color
 * @param {*} color
 */
const getOlColor = (inputColor) => {
  if (!(/^string$/.test(typeof inputColor) || Array.isArray(inputColor))) {
    return null;
  }
  let olColor = inputColor;
  if (typeof olColor === "string") {
    if (
      !/rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+))?\s*\)/.test(
        olColor,
      )
    ) {
      return null;
    }
    // The background color is returned as an rgba string from the kml reader, so we need to convert to array
    const match = inputColor.match(
      /rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+))?\s*\)/,
    );
    olColor = [match[1], match[2], match[3], match[4] || 1].map((val) => {
      return parseFloat(val, 10);
    });
  }
  return olColor;
};

export default getOlColor;
